<template>
    <div v-if="!loading" class="mid">
        <b-link class="back" @click="goBack"><svg-icon icon="back" /></b-link>
        <h1>{{ title }}</h1>
        <div class="bg-white rounded p-4 d-flex flex-column align-items-center justify-content-center text-center">
            <div v-if="intro" v-html="intro"></div>
            <div v-else-if="duration" class="text-center"><p>{{ $t('completeAssessmentTime', [duration[0] + ' ' + $t(duration[1]).toLowerCase()]) }}</p></div>
        </div>
        <b-button class="p-3 mt-5" block variant="primary" @click="$emit('start')">{{ $t('start') }}</b-button>
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
export default {
    name: "AssessmentIntro",
    components: {
        SvgIcon
    },
    props: {
        title: String,
        intro: String,
        duration: {
            type: Array,
            default: null,
        },
        loading: Boolean,
        textDir: {
            type: String,
            default: ''
        }
    },
    methods: {
        goBack() {
            if (this.$store.getters.getSecureAssessment) {
                if (this.$store.getters.getAI) {
                    this.$emit('proceed', 'ai');
                } else if (this.$store.getters.getCaptureScreens) {
                    this.$emit('proceed', 'popup');
                } else {
                    this.$emit('proceed', 'permissions');
                }
            } else if (this.$store.getters.getAssessmentAgreement) {
                this.$emit('proceed', 'agreement');
            } else {
                this.$router.push('/assessments');
            }
        }
    }
}

</script>
